import { h } from 'preact'

const UnreadByTeam = () =>
  ({ moderationStatus: { repliedSinceLastModeration, isModerated } } : { moderationStatus: { repliedSinceLastModeration: number, isModerated: boolean }}) =>
    <div class='overview__unread-by-team'>
      { !isModerated && <div>New topic{repliedSinceLastModeration > 0 && (' (+' + repliedSinceLastModeration + ')')}</div>}
      { isModerated && repliedSinceLastModeration > 0 && <div>+ { repliedSinceLastModeration } Replies</div> }
    </div>
export default UnreadByTeam
